import { Box, Button, Container, Grid, Group, ScrollArea, Text, useMantineTheme } from '@mantine/core';
import { useElementSize, useMediaQuery } from '@mantine/hooks';
import React, { useState } from 'react';
import NoDataFound from '../../components/NoDataFound';
import { convertTo24HourFormat, toastError, toastSuccess, US_Currency_Space } from '../../config/Helper';
import { AxiosResponse, isAxiosError } from 'axios';
import { IBaseResponseError } from '../../typescript/interfaces/common.interface';
import { getReceiptDetails } from '../../utils/detailsData';
import { buttonStyle } from '../../utils/styles/GlobalStyle';
import { useLocation } from 'react-router-dom';
import { sendReceiptService } from '../../services/receipt/receipt.service';

const Reciept = () => {
  const [receiptDetails, setReceiptDetails] = useState(getReceiptDetails);
  const theme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const { ref, height } = useElementSize();
  const { classes: buttonClass } = buttonStyle();
  const location = useLocation();
  const { data } = location.state;
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  console.log(data);

  const sendReceipt = async () => {
    setButtonLoading(true);
    try {
      const formData = {
        choice: data.user.email ? 'email' : 'phone',
      };
      const receiptData = await sendReceiptService(data.order.order_id, formData);
      setButtonLoading(false);
      toastSuccess(receiptData.data.message);
    } catch (error: unknown) {
      console.error(error);
      if (isAxiosError(error)) {
        const response = error.response as AxiosResponse<IBaseResponseError> | undefined;
        const data = response?.data;
        const hasApiError = data?.data?.error_type && data?.data?.error_message;
        // toastError(hasApiError ? data : data?.message);
      }
      setButtonLoading(false);
    }
  };

  const printReceipt = () => {
    window.print();
  };

  return (
    <>
      <Container w='100%'>
        <div ref={ref}>
          <Grid>
            <Grid.Col span={2} ta='left'>
              <Text pb={20} fz='16px' fw={500} color={'black'}>
                RECEIPT
              </Text>
            </Grid.Col>
          </Grid>
        </div>
        <ScrollArea type='never' h={window.innerHeight - (height + 80)}>
          <Box pt={0} pl={'15px'} w='100%'>
            <Grid m={0}>
              <Grid.Col span={6} sm={8} p={0} ta='left'>
                <Text fw={450} fz={mobile ? '11px' : '13px'} color={'red'}>
                  Served By
                </Text>
                <Text fz={mobile ? '12px' : '14px'} pt={'5px'} fw={500} color={'black'}>
                  {data.restaurant.name}
                </Text>
                <Text fz={mobile ? '11px' : '13px'} pt={'5px'} fw={450} color={'black'}>
                  {data.full_address}
                </Text>
                <Text fz={mobile ? '11px' : '13px'} pt={'10px'} fw={500} color={'black'}>
                  Call: +{receiptDetails[0]?.servedBy?.contact}
                </Text>
                <Text fz={mobile ? '11px' : '13px'} fw={450} color='red' pt={'20px'}>
                  Order Placed at
                </Text>
                <Text fz={mobile ? '11px' : '13px'} fw={500} color='black'>
                  {convertTo24HourFormat(data.order.time_logs.placed_at)}
                </Text>

                <Text fz={mobile ? '12px' : '14px'} color='red' fw={500} pt={'15px'}>
                  Order ID #{data.order.order_id}
                </Text>
              </Grid.Col>

              <Grid.Col span={6} sm={4} p='0px 0px 0px 25px' ta={'left'}>
                <Text fw={450} fz={mobile ? '11px' : '13px'} color={'red'}>
                  Ordered By
                </Text>
                <Text fz={mobile ? '12px' : '14px'} pt={'5px'} fw={500} color={'black'}>
                  {data.user.name}
                </Text>
                <Text fz={mobile ? '11px' : '13px'} fw={450} color={'black'}>
                  {receiptDetails[0]?.orderedBy?.userRole}
                </Text>
                <Text fz={mobile ? '11px' : '13px'} pt={'5px'} fw={500} color={'black'}>
                  {data.user.email}
                </Text>
                {data.user.phone_number && (
                  <Text fz={mobile ? '11px' : '13px'} fw={500} color={'black'}>
                    Call: +{data.user.phone_number}
                  </Text>
                )}
                <Text fz={mobile ? '11px' : '13px'} fw={450} color='red' pt={'20px'}>
                  Ready to pickup at
                </Text>
                <Text fz={mobile ? '11px' : '13px'} fw={500} color='black'>
                  {convertTo24HourFormat(data.order.time_logs.ready_to_serve_at)}
                </Text>
              </Grid.Col>
            </Grid>

            <Text fz={mobile ? '12px' : '14px'} fw={500} color='red' pt={'20px'} align='left'>
              Bill Details
            </Text>
            {data.order.details.items.length ? (
              data.order.details.items.map((item: any, id: number) => (
                <React.Fragment key={id}>
                  <Group display={'flex'} fw={500} pt={'10px'} style={{ justifyContent: 'space-between' }}>
                    <Text fz={mobile ? '11px' : '13px'} color='black'>
                      {item.name} X {item.quantity}
                    </Text>
                    <Text fz={mobile ? '11px' : '13px'} color='black'>
                      ${item.price * item.quantity}
                    </Text>
                  </Group>

                  {item.addons.length
                    ? item.addons.map((element: any, index: any) => (
                        <React.Fragment key={index}>
                          <Group display={'flex'} fw={500} pt={'10px'} style={{ justifyContent: 'space-between' }}>
                            <Text fz={mobile ? '11px' : '13px'} color='black'>
                              {`${element?.item_choice}(${element?.addon_level})`} X {item?.quantity}
                            </Text>
                            <Text fz={mobile ? '11px' : '13px'} color='black'>
                              ${element?.amount * item?.quantity}
                            </Text>
                          </Group>
                        </React.Fragment>
                      ))
                    : null}
                </React.Fragment>
              ))
            ) : (
              <NoDataFound text='No item found.' />
            )}

            <Group display={'flex'} pt={'25px'} fw={500} style={{ justifyContent: 'space-between' }}>
              <Text fz={mobile ? '11px' : '13px'} color='black'>
                Item Sub Total
              </Text>
              <Text fz={mobile ? '11px' : '13px'} color='black'>
                ${data.order.details.price.total_amount}
              </Text>
            </Group>
            <Group display={'flex'} fw={500} pt={'10px'} style={{ justifyContent: 'space-between' }}>
              <Text fz={mobile ? '11px' : '13px'} color='black'>
                Discount
              </Text>
              <Text fz={mobile ? '11px' : '13px'} color='black'>
                - ${data.order.details.price.coupon_discount}
              </Text>
            </Group>
            <Group display={'flex'} fw={500} pt={'10px'} style={{ justifyContent: 'space-between' }}>
              <Text fz={mobile ? '11px' : '13px'} color='black'>
                Amount With Tax
              </Text>
              <Text fz={mobile ? '11px' : '13px'} color='black'>
                ${data.order.amount_with_tax}
              </Text>
            </Group>
            {/* <Group display={'flex'} fw={500} pt={'10px'} style={{ justifyContent: 'space-between' }}>
              <Text fz={mobile ? '11px' : '13px'} color='black'>
                Service Charge
              </Text>
              <Text fz={mobile ? '11px' : '13px'} color='black'>
                {US_Currency_Space(receiptDetails[0]?.serviceCharge)}
              </Text>
            </Group> */}

            <Group display={'flex'} pt={'20px'} style={{ justifyContent: 'space-between' }}>
              <Text fz={mobile ? '16px' : '17px'} fw={500} color='black'>
                Item Total
              </Text>
              <Text fz={mobile ? '16px' : '17px'} fw={500} color='black'>
                ${data.order.amount_with_tax}
                {/* {US_Currency_Space(
                  receiptDetails[0]?.serviceCharge + receiptDetails[0]?.itemSubTotal - receiptDetails[0]?.discount,
                )} */}
              </Text>
            </Group>

            {/* <Box pt='30px'>
              <Text fz={mobile ? '12px' : '14px'} fw={450} color='red' align='left'>
                Amount Charged
              </Text>
              <Text fw={500} fz={mobile ? '12px' : '14px'} color='black' align='left'>
                Visa | Card ending with 4789
              </Text>
            </Box> */}

            <Group
              display={'flex'}
              pt={'20px'}
              style={{ justifyContent: 'space-between' }}
              pos='sticky'
              bottom={0}
              bg='white'>
              <Button
                px={50}
                fw={500}
                className={buttonClass.buttonShadow}
                radius={'11px'}
                size='xl'
                fz={'16px'}
                maw='250px'
                variant={'outline'}
                color='red'
                loading={buttonLoading}
                onClick={sendReceipt}>
                {data.user.email ? 'Email' : 'SMS'}
              </Button>
              <Button
                px={30}
                fw={500}
                className={buttonClass.buttonShadow}
                radius={'11px'}
                size='xl'
                fz={'16px'}
                maw='250px'
                variant={'filled'}
                color='red'
                onClick={printReceipt}>
                Download
              </Button>
            </Group>
          </Box>
        </ScrollArea>
      </Container>
    </>
  );
};

export default Reciept;
